export default "__VITE_ASSET__D3Kzwk$l__"